import { render, staticRenderFns } from "./curriculumToExamine.vue?vue&type=template&id=6d9fa8b4"
import script from "./curriculumToExamine.vue?vue&type=script&lang=js"
export * from "./curriculumToExamine.vue?vue&type=script&lang=js"
import style0 from "./curriculumToExamine.vue?vue&type=style&index=0&id=6d9fa8b4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports